<template>
  <section class="section section__header" :class="{section__header_iphone: isIPhone}" ref="firstScreen">
      <div class="section__header-background"></div>
      <div class="headline_decor__wrapper">
        <p class="headline headline_decor _loading-anim__hedline _loading-anim__hedline_step--1">
          {{ headline.text[0] }} {{ headline.text[1] }}
        </p>
      </div>
      <div class="headline__menu">
          <div v-for="item in menu" :key="item.id" class="headline__menu__item-wrapper"
              :class="`headline__menu__${item.class}`">
              <div class="headline__menu__hr"></div>
              <div class="headline__menu__item">
                  <div class="menu__item--wrapper">
                    <span class="menu__item__id _loading-anim__hedline _loading-anim__hedline_step--2">{{ `0${item.id}` }}</span>
                    <span class="menu__item__name _loading-anim__hedline _loading-anim__hedline_step--2">{{ item.name }}</span>
                  </div>
                  <div class="menu__item--wrapper">
                    <div class="anim-span__wrapper">
                      <span class="menu__item__text _loading-anim__hedline _loading-anim__hedline_step--3">{{ item.text }}</span>
                    </div>
                    <div class="anim-span__wrapper">
                      <router-link :to="item.link" class="button button--no-delay _loading-anim__header-btns">
                          <span>подробнее</span>
                          <div class="button__icon"></div>
                      </router-link>
                    </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

  export default {
      components: {
      },
      data() {
          return {
              headline: {
                  text: ['Cмешиваем лучшие решения в области автоматизации', 'и поддержки сложных IT-инфраструктур']
              },
              menu: [{
                      id: 1,
                      name: 'Решения',
                      class: 'solutions',
                      text: 'Корпоративный портал, база знаний, крупные корпоративные внедрения, корпоративное мобильное приложение, решения для HR, автоматизация процессов',
                      link: '/solutions'
                  },
                  {
                      id: 2,
                      name: 'услуги',
                      class: 'services',
                      text: 'Бизнес-консалтинг, внедрение Битрикс24, техподдержка информационных систем, мониторинг, брендирование',
                      link: '/services'
                  },
                  {
                      id: 3,
                      name: 'продукты',
                      class: 'products',
                      text: 'Битрикс24, NBT, iMpact, Naumen, Kaiten, EmplDocs, HRlink, Una Knows, Una Contacts, UX-мониторинг, RPA',
                      link: '/products'
                  }
              ],
              heightContentIsMoreScrene: false}
      },
    computed: {
      ...mapGetters(['widthPage', 'isActive', "isIPhone", 'isSafari', 'heightFirstScreen']),
      headlinePadding() {
        if (this.widthPage > 1680) {
          return (this.widthPage - 1680)/2
        }
        return 0
      }
    },
    methods: {
      ...mapMutations(['setHeightFirstScreen']),
      setHeightContentIsMoreScrene() {
        if(!this.isIPhone) {
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
        if(this.isIPhone){
          let buttonbarHeight = 90;
          document.documentElement.style.setProperty('--buttonbarHeight', `${buttonbarHeight}px`);
        }
        const headlineDcor = document.querySelector('.section__header .headline_decor__wrapper')
        const headerMenuWrapperHeight = document.querySelector('.section__header .headline__menu').offsetHeight
        const headerHeight = document.querySelector('.header-wrapper').offsetHeight
        const headkineDcorHeight =
          headlineDcor.offsetHeight +
          Number(window.getComputedStyle(headlineDcor).marginTop.replace('px', '')) +
          Number(window.getComputedStyle(headlineDcor).marginBottom.replace('px', ''))

        const firstScrebeMinHeight = headerMenuWrapperHeight + headerHeight + headkineDcorHeight
        this.heightContentIsMoreScrene = window.innerHeight > firstScrebeMinHeight

        this.setHeightFirstScreen(Math.floor(this.$refs.firstScreen.getBoundingClientRect().height))
      }
    },
    mounted() {
      this.setHeightContentIsMoreScrene()
      window.addEventListener('resize', this.setHeightContentIsMoreScrene)
    },
    destroyed() {
      window.removeEventListener('resize', this.setHeightContentIsMoreScrene)
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/mixins";
@import "../../../assets/styles/variables";
  .anim-span__wrapper {
    overflow: hidden;
    >span {
      display: inline-flex;
    }
  }
  .header__background {
      position: absolute;
      overflow: hidden;
      z-index: 0;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100%;
      background-color: #0A177C;

      .header__background__video {
          opacity: .065;
          position: absolute;
          top: 0;
          width: auto;
          height: 100vmax;
      }
    }
  .section {
    &__header {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      max-width: unset;
      height: calc(100vh - var(--headerHeight));

      transition: padding-top .3s;
      padding-top: var(--headerHeight);

      @include mediumLaptop {
        padding-right: var(--mainPaddingSmallSize);
        padding-left: var(--mainPaddingSmallSize);
      }

      @include smallLaptop {
        padding-top: var(--headerHeightMobile);
        min-height: calc(100vh - var(--headerHeightMobile));
        height: 100vh; /* Fallback for browsers that do not support Custom Properties */
        height: calc(var(--vh, 1vh) * 100 - var(--headerHeightMobile));
      }

      @include largePhonesAlt {
        min-height: 100vh;
        min-height: calc(var(--vh, 1vh) * 100 - var(--headerHeightMobile));
        height: fit-content;
      }

      @include largePhones {
        overflow: hidden;
      }

      &_iphone {
        background-color: var(--color1);
        background-image: url('../../../assets/background-for-iphone.gif');
        background-size: cover;
        background-position: center;
      }

    .headline_decor__wrapper {
      overflow: hidden;
      margin-top: 68px;
      display: flex;
      justify-content: center;
      width: 98vw;
      height: fit-content;
      position: relative;
      left: 0;
      // background: linear-gradient(180deg, rgba(0,29,130,0) 51px, rgba(255,255,255,1) 51px, rgba(0,29,130,0) 52px);
      background-size: 100% 52px;
      background-repeat: repeat;
      background-position-y: 1px;

      @include desctop {
        margin-top: 30px;
      }

      @include laptop {
        margin-top: 30px;
      }

      @include largePhonesAlt  {
          margin-top: 5px;
          margin-bottom: 5px;
      }
    }
    .headline_decor {
      max-width: 1680px;
      box-sizing: border-box;
      position: relative;
      &:first-letter {
        margin-left: 277px;
      }
      &:before {
        content: '';
        position: absolute;
        height: 52px;
        background-position-y: center;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%3Csvg width='257' height='31' viewBox='0 0 257 31' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.07969 0L15.5 0.031534L21.9203 0L25.5226 3.63781C28.2187 1.36773 31.6996 0 35.5 0C43.0486 0 49.3369 5.39608 50.7179 12.5413L57.4218 0.995748L58 0L58.5782 0.995746L63.3374 9.19212C65.7535 3.7755 71.1858 0 77.5 0H105.5C109.044 0 112.31 1.18921 114.921 3.19033L118.08 0L124.5 0.031534L130.92 0L134.523 3.63781C137.219 1.36773 140.7 0 144.5 0C144.668 0 144.836 0.00267525 145.002 0.0079855L145 0H146.041H227L231 13.7778L238.422 0.995748L239 0L239.578 0.995746L256.419 30L257 31H255.844H236H234.959H222.156H221H154L153.221 28.3158C150.736 30.0097 147.734 31 144.5 31C140.7 31 137.219 29.6323 134.523 27.3622L130.92 31L124.5 30.9685L118.08 31L114.921 27.8097C112.31 29.8108 109.044 31 105.5 31H77.5C76.9789 31 76.4638 30.9743 75.9559 30.9241L76 31H74.8437H41.1564H40L40.4733 30.1849C38.9122 30.7134 37.2396 31 35.5 31C31.6996 31 28.2187 29.6323 25.5226 27.3622L21.9203 31L15.5 30.9685L9.07969 31L4.56214 26.4379L0 21.9203L0.0315335 15.5L0 9.07969L4.56214 4.56214L9.07969 0ZM222.737 30H234.668L230.691 16.301L222.737 30ZM230.306 14.9733L221.581 30H154.751L154.079 27.6864C157.685 24.8483 160 20.4445 160 15.5C160 8.8723 155.84 3.21617 149.989 1H226.249L230.306 14.9733ZM231.385 15.1054L235.71 30H255.263L239 1.99149L231.385 15.1054ZM144.5 1C144.767 1 145.033 1.00723 145.297 1.02151L152.926 27.3017C150.551 29.0003 147.642 30 144.5 30C140.974 30 137.742 28.7415 135.229 26.6491L135.438 26.4379L140 21.9203L139.968 15.5L140 9.07969L135.438 4.56214L135.229 4.35088C137.742 2.25853 140.974 1 144.5 1ZM146.366 1.11898L153.777 26.6446C156.969 23.9848 159 19.9796 159 15.5C159 8.12419 153.493 2.03465 146.366 1.11898ZM134.481 5.01762L134.727 5.2658L134.734 5.27271L138.998 9.49475L138.968 15.4951L138.968 15.5049L138.998 21.5052L134.734 25.7272L134.727 25.7342L134.482 25.9824C131.72 23.3424 130 19.6221 130 15.5C130 11.378 131.72 7.65764 134.481 5.01762ZM133.778 4.30694C130.833 7.12828 129 11.1 129 15.5C129 19.9 130.833 23.8717 133.778 26.6931L130.505 29.9979L124.505 29.9684L124.495 29.9685L118.495 29.9979L115.698 27.1732C118.947 24.332 121 20.1557 121 15.5C121 10.8443 118.947 6.668 115.698 3.82676L118.495 1.00205L124.495 1.03157L124.505 1.03152L130.505 1.00205L133.778 4.30694ZM58 1.99149L62.8675 10.3744C62.3056 11.9788 62 13.7037 62 15.5C62 22.1277 66.1598 27.7838 72.0109 30H41.737L41.9775 29.5857C47.3032 27.1326 51 21.748 51 15.5C51 15.0442 50.9803 14.5931 50.9418 14.1473L58 1.99149ZM63 15.5C63 22.3081 67.692 28.0203 74.0188 29.5794L63.5464 11.5435C63.1905 12.8012 63 14.1284 63 15.5ZM63.9684 10.2789L75.3253 29.838C76.0347 29.9447 76.7609 30 77.5 30H105.5C108.769 30 111.786 28.9181 114.211 27.0929L113.562 26.4379L109 21.9203L109.032 15.5L109 9.07969L113.562 4.56214L114.211 3.90707C111.786 2.08185 108.769 1 105.5 1H77.5C71.3325 1 66.0643 4.85063 63.9684 10.2789ZM120 15.5C120 11.1222 118.06 7.19748 114.993 4.53881L114.273 5.26577L114.266 5.27275L110.002 9.49475L110.032 15.4951L110.032 15.5049L110.002 21.5052L114.266 25.7273L114.273 25.7342L114.993 26.4612C118.06 23.8025 120 19.8778 120 15.5ZM49.9975 15.7736C49.9016 20.955 47.0879 25.472 42.9221 27.959L49.9975 15.7736ZM49.9153 13.9236L41.2748 28.8044C39.5053 29.5736 37.5525 30 35.5 30C31.974 30 28.742 28.7415 26.2287 26.6491L26.4379 26.4379L31 21.9203L30.9685 15.5L31 9.07969L26.4379 4.56214L26.2287 4.35088C28.742 2.25853 31.974 1 35.5 1C42.9755 1 49.1297 6.657 49.9153 13.9236ZM21.5052 1.00205L24.7778 4.30691C21.8333 7.12825 20 11.1 20 15.5C20 19.9 21.8333 23.8717 24.7778 26.6931L21.5052 29.9979L15.5049 29.9685V29.9684L15.4951 29.9685L9.49475 29.9979L5.27271 25.7342L5.27275 25.7342L5.26577 25.7273L1.00205 21.5052L1.03152 15.5049H1.03157L1.03152 15.4951L1.00205 9.49475L5.26577 5.27271L5.2658 5.27275L5.27271 5.26577L9.49475 1.00205L15.4951 1.03152V1.03157L15.5049 1.03152L21.5052 1.00205ZM21 15.5C21 19.6221 22.72 23.3424 25.4815 25.9824L25.7273 25.7342L25.7342 25.7272L25.7342 25.7273L29.9979 21.5052L29.9685 15.5049L29.9684 15.4951L29.9685 15.4951L29.9979 9.49475L25.7342 5.27271L25.7272 5.2658L25.7273 5.26577L25.4815 5.01759C22.72 7.65761 21 11.3779 21 15.5Z' fill='url(%23paint0_linear)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='1.92026e-07' y1='16' x2='257' y2='16' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FFD200'/%3E%3Cstop offset='0.542526' stop-color='%23E62315'/%3E%3Cstop offset='1' stop-color='%23462DC7'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
        width: 100%;
      }

      &:after {
        content: '';
        display: inline-block;
        margin-left: 23px;
        margin-bottom: -3px;
        width: 60px;
        height: 40px;
        background-position-y: center;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%3Csvg width='61' height='29' viewBox='0 0 61 29' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 17.8V18.6L20.24 28.44V27.52L1 18.2L20.24 8.84V7.96L0 17.8Z' fill='url(%23paint0_linear)'/%3E%3Cpath d='M24.7494 29L36.3494 0H35.5094L23.8694 29H24.7494Z' fill='url(%23paint1_linear)'/%3E%3Cpath d='M60.2103 17.8L39.9703 7.96V8.84L59.2103 18.2L39.9703 27.52V28.44L60.2103 18.6V17.8Z' fill='url(%23paint2_linear)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='4.23513e-08' y1='14.9677' x2='60.2103' y2='14.9677' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FFD200'/%3E%3Cstop offset='1' stop-color='%23E62315'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear' x1='4.23513e-08' y1='14.9677' x2='60.2103' y2='14.9677' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FFD200'/%3E%3Cstop offset='1' stop-color='%23E62315'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear' x1='4.23513e-08' y1='14.9677' x2='60.2103' y2='14.9677' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FFD200'/%3E%3Cstop offset='1' stop-color='%23E62315'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
      }
      @include smallDesktop {
        margin-right: 20px;
        &:before {
          height: 45px;
          background-position-y: 7px;
        }
      }

      @include smallLaptop {
        &:first-letter {
          margin-left: 170px;
        }

        &:before {
          background-size: 160px;
          background-position-y: 4px;
        }

        &:after {
          margin-left: 0;
          height: 20px;
          background-size: 75%;
          background-position-y: 0;
          margin-bottom: 0;
        }
      }

      @include largePhonesAlt {
        margin-right: 10px;
        font-size: 15px;
      }

      @media (max-width: 561px) {
        font-size: 17px;
      }

      @media (max-width: 450px) {
        font-size: 15px;
      }

      @media (max-width: 410px) {
        font-size: 14px;
      }

      @media (max-width: 390px) {
        font-size: 17.5px;
      }

      @media (max-width: 330px) {
        font-size: 15px;
      }

      @include mediumPhones {
        &:before {
          background-size: 135px;
        }

        &:first-letter {
          margin-left: 145px;
        }
      }

      @include smallPhones {
        &:after {
          background-size: 100% 100%;
          height: 16px;
          max-width: 40px;
        }
      }
     }
    }
  }
    .headline {
        position: relative;
        box-sizing: border-box;
        align-items: flex-start;
        margin: 0 0 2px 0;
        width: 100%;
        text-align: left;
        justify-content: flex-start;
        font-style: normal;
        font-weight: normal;
        font-size: 40px;
        line-height: 130%;
        text-transform: uppercase;
        color: var(--color5);
        background: linear-gradient(180deg, rgba(0, 29, 130, 0) 40px, white 40px, rgba(0, 29, 130, 0) 41px);
        background-size: 100% 50px;
        background-position-y: 10px;

        @include smallDesktop {
          font-size: 32px;
          line-height: 45px;
          background: linear-gradient(180deg, rgba(0, 29, 130, 0) 40px, white 40px, rgba(0, 29, 130, 0) 41px);
          background-size: 100% 45px;
          background-position-y: 8px;
        }

        @include smallLaptop {
          font-size: 20px;
          line-height: 28px;
          background: linear-gradient(180deg, rgba(0, 29, 130, 0) 26px, white 26px, rgba(0, 29, 130, 0) 27px);
          background-size: 100% 27px;
          background-position-y: 1px;
        }

        @include mediumPhones {
          // margin-top: 30px;
          // margin-bottom: 15px;
          margin: 0;
          font-size: 16px;
          line-height: 23px;

          background: linear-gradient(180deg, rgba(0, 29, 130, 0) 21px, white 21px, rgba(0, 29, 130, 0) 22px);
          background-size: 100% 23px;
          background-position-y: 2px;
        }

        @include smallPhones {
          line-height: 24px;
          background: linear-gradient(180deg, rgba(0, 29, 130, 0) 21px, white 21px, rgba(0, 29, 130, 0) 22px);
          background-size: 100% 24px;
          background-position-y: 3px;
          border-bottom: 1px solid rgba(255, 255, 255, .15);
    }
}

  @keyframes anim1 {
      0% {
          height: 1px;
          width: calc(100% - 40px);
          left: 20px;
      }

      35% {
          height: 1px;
          width: 100%;
          left: 0;
      }

      100% {
          height: 100%;
          width: 100%;
          left: 0;
      }
  }

  @keyframes anim2 {
      0% {
          height: 100%;
          width: 100%;
          left: 0;
      }

      75% {
          height: 1px;
          width: 100%;
          left: 0;
      }

      100% {
          height: 1px;
          width: calc(100% - 40px);
          left: 20px;
      }
  }

  .headline__menu {
      height: fit-content;
      display: flex;
      flex-direction: column;
      width: calc(100% + 40px);
      max-width: 1700px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 20px;
      background: transparent;

      @include desctop {
        position: relative;
        left: -20px;
      }

      @include laptop {
        margin-bottom: 0;
      }

      .menu__item {
        @include mediumLaptop {
          &__name {
            font-size: 55px;
          }

          &__id {
            margin-right: 55px;
          }

          &__text {
            margin-right: 13px;
          }

          .button {
            span {
              font-size: 14px;
            }
          }
        }
        @include smallLaptop {
          &__name {
            line-height: .8em;
          }

          &__id {
            margin-right: 37px;
          }
        }

        @include phones {
          &__name {
            font-size: 32px;
          }
        }
      }

      &__item-wrapper {
          overflow: hidden;
          position: relative;
          display: flex;
          align-items: flex-start;
          width: 100%;
          height: 130px;
          box-sizing: border-box;
          padding: 25px 20px;
          transition: all .35s ease;
          transform: translateZ(0);

          &:hover {
              height: 180px;

              @include desctop {
                height: 130px;
              }

              @include smallLaptop {
                height: fit-content;
              }

              .headline__menu__hr {
                &.bebe {
                    transition: all .35s ease;
                    height: 100%;
                    left: 0;
                    width: 100%;
                    // animation: anim1 0.35s ease 0.1s 1 forwards alternate;
                  }
              }

              .button {
                  background-color: #fff;

                  span {
                      color: var(--color1);
                  }

                  .button__icon {
                      background-image: url("data:image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 4.5L9.32925 4.87629V4.12371L9 4.5ZM6 1.875H5.5V2.10188L5.67075 2.25129L6 1.875ZM6 7.125L5.67075 6.74871L5.5 6.89812V7.125H6ZM9.32925 4.12371L7.32925 2.37371L6.67075 3.12629L8.67075 4.87629L9.32925 4.12371ZM7.32925 2.37371L6.32925 1.49871L5.67075 2.25129L6.67075 3.12629L7.32925 2.37371ZM6.5 1.875V0.5H5.5V1.875H6.5ZM8.67075 4.12371L6.67075 5.87371L7.32925 6.62629L9.32925 4.87629L8.67075 4.12371ZM6.67075 5.87371L5.67075 6.74871L6.32925 7.50129L7.32925 6.62629L6.67075 5.87371ZM5.5 7.125V8.5H6.5V7.125H5.5Z' fill='%23001D82'/%3E%3Cline x1='4.37114e-08' y1='4.5' x2='6' y2='4.5' stroke='%23001D82'/%3E%3C/svg%3E");
                  }
              }

              &.headline__menu__products {
                  .menu__item__text {
                      color: var(--color1);
                      transition: all 0s ease;
                      transition-delay: 0.3s;
                      transform: translateZ(0);
                  }
              }
          }

          @include smallLaptop {
            padding: 9px 20px;
            height: fit-content;
            min-height: 150px;
          }
          @include largePhones {
            //height: fit-content;
          }
      }
      &__item {
          display: flex;
          align-items: flex-start;
          width: 100%;
          max-width: var(--large);
          margin: 0 auto;
          flex-flow: row;
          .menu__item--wrapper:last-child {
            margin-left: auto;
            @include mediumPhones {
              margin-left: 0;
            }
          }
          @include largePhones {
            display: flex;
            flex-flow: column;
          }
      }

      &__solutions,
      &__services,
      &__products {
          .headline__menu__hr {
              width: 0;
              z-index: -1;
              position: absolute;
              top: 0;
              left: 20px;
              height: 1px;
              &.bebe {
                width: calc(100% - 40px);
                transition: all .35s ease;
                transform: translateZ(0);
                // animation: anim2 0.35s ease 0s 1 forwards alternate;
              }
          }
      }

      &__solutions {
          .headline__menu__hr {
              background-color: var(--color2);
          }
      }

      &__services {
          .headline__menu__hr {
              background-color: var(--color3);
          }
      }

      &__products {
          .menu__item__text {
              transition: all 0s ease;
              transform: translateZ(0);
              // transition-delay: 0.15s;
          }

          .headline__menu__hr {
              background-color: var(--color4);
          }
      }
  }

  .menu__item--wrapper {
    display: flex;

    &:last-child {
      margin-left: auto;
      @include smallLaptop {
        flex-flow: column;

        .button {
          width: 138px;
          margin-top: 20px;
          padding-top: 0;
          padding-bottom: 0;
        }
      }

      @include largePhones {
        margin-left: 0;
      }
    }
      @include largePhones {
        margin-left: 0;
        margin-bottom: 12px;
      }

      @include largePhonesAlt {
        flex-flow: row;
      }
  }

  .menu__item__id {
      margin-right: 258px;
      justify-content: flex-start;
      align-self: flex-start;
      color: red;
      font-family: 'SuisseIntl';
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 21px;
      text-transform: uppercase;

      .headline__menu__solutions & {
          color: var(--color2);
      }

      .headline__menu__services & {
          color: var(--color3);
      }

      .headline__menu__products & {
          color: var(--color4);
      }

      @include mediumDesctop {
        margin-right: 100px;
      }

      @include mediumPhones {
        font-size: 12px;
      }
  }

  .menu__item__name {
      font-family: 'SuisseIntl';
      font-style: normal;
      font-weight: normal;
      font-size: 100px;
      line-height: 85px;
      text-transform: uppercase;
      color: #FFFFFF;
      @include mediumDesctop {
        font-size: 80px;
        line-height: .7em;
      }
  }

  .menu__item__text {
      margin: 0 93px 0 0;
      max-width: 395px;
      min-width: 395px;
      font-family: 'SuisseIntl';
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 140%;
      color: #FFFFFF;
      @include mediumDesctop {
        margin-right: 22px;
      }
      @include mediumPhones {
        min-width: unset;
        max-width: unset;
      }
  }

  .button {
      .headline__menu__solutions & {
          background-color: var(--color2);
      }

      .headline__menu__services & {
          background-color: var(--color3);
      }

      .headline__menu__products & {
          background-color: var(--color4);

          span {
              color: var(--color1);
          }
      }

      .button__icon {
          .headline__menu__products & {
              background-image: url("data:image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 4.5L9.32925 4.87629V4.12371L9 4.5ZM6 1.875H5.5V2.10188L5.67075 2.25129L6 1.875ZM6 7.125L5.67075 6.74871L5.5 6.89812V7.125H6ZM9.32925 4.12371L7.32925 2.37371L6.67075 3.12629L8.67075 4.87629L9.32925 4.12371ZM7.32925 2.37371L6.32925 1.49871L5.67075 2.25129L6.67075 3.12629L7.32925 2.37371ZM6.5 1.875V0.5H5.5V1.875H6.5ZM8.67075 4.12371L6.67075 5.87371L7.32925 6.62629L9.32925 4.87629L8.67075 4.12371ZM6.67075 5.87371L5.67075 6.74871L6.32925 7.50129L7.32925 6.62629L6.67075 5.87371ZM5.5 7.125V8.5H6.5V7.125H5.5Z' fill='%23001D82'/%3E%3Cline x1='4.37114e-08' y1='4.5' x2='6' y2='4.5' stroke='%23001D82'/%3E%3C/svg%3E");
          }
      }
  }
</style>
